import $ from 'jquery';

document.addEventListener('DOMContentLoaded', () => {
    let values = [];

    const typingDelay = 125;
    const wordDelay = 4000;
    const erasedDelay = 600;

    let text = '';
    let index = -1;
    let DOMText = null;

    const setDOM = (setText) => {
        DOMText.innerHTML = setText;
    };

    const eraseCurrentText = () => {
        if (text !== '') {
            text = text.slice(0, -1);
            setDOM(text);
            setTimeout(eraseCurrentText, typingDelay);
        }
    };

    const typeNextText = (nextText) => {
        if (nextText !== '') {
            text = `${text}${nextText[0]}`;
            setDOM(text);
            setTimeout(() => {
                typeNextText(nextText.slice(1));
            }, typingDelay);
        }
    };

    const startTypingAnimation = () => {
        if (values) {
            const oldText = text;
            eraseCurrentText();
            index += 1;
            const nextText = values[index % values.length];
            setTimeout(() => {
                typeNextText(nextText);
                setTimeout(startTypingAnimation, wordDelay);
            }, (erasedDelay + (oldText.length * typingDelay)));
        } else {
            setTimeout(startTypingAnimation, wordDelay);
        }
    };

    if ($('#written')) {
        DOMText = document.getElementById('written');
        if (DOMText) {
            $('document').ready(startTypingAnimation);
            values = JSON.parse(DOMText.parentElement.getAttribute('data-written-texts'));
        }
    }
});
